export var LINK_TAG_TYPES = {
    RSS: 'application/rss+xml',
    PREV: 'prev',
    NEXT: 'next',
};
